import React from 'react';
import $ from 'jquery';
import {GetParams, MWBaseURL} from './../Utilities.js'
import {createApiClient} from "../api/ApiClient";

class FirmFilter extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			firm: null,

			needToUpdate: false,
			updateCount: 0,
      isDropdownOpen: false
		};
    this.selectRef = React.createRef();
	}

	static getDerivedStateFromProps(props, state) {
		let obj = {}
		if(state.date !== props.date || state.firm !== props.firm){
			obj = {...props, needToUpdate: true}
		}
		if(state.updateCount !== props.updateCount){
			obj.updateCount = props.updateCount
			obj.needToUpdate = true
		}
		return obj;
	}

	componentDidUpdate(props, state){
		let self = this
		if(this.state.needToUpdate && !this.state.isDropdownOpen){
			this.setState({needToUpdate: false}, function(){
				self.load()
			})
		}
	}

	componentDidMount() {
		this.load()
    $(this.selectRef.current).on('show.bs.select', () => {
      this.setState({ isDropdownOpen: true });
    });

    $(this.selectRef.current).on('hide.bs.select', () => {
      this.setState({ isDropdownOpen: false });
    });
	}

	setFilterValue = (e) => {
		let self = this
		let val = Array.from(e.target.selectedOptions, option => option.value);
		self.setState({firm: val}, function(){
			self.state.refilter({
				selectedFirm: val,
				selectedAcct: []
			})
		})
		
	}

	clearFilter = () => {
		this.state.refilter({
			selectedFirm: ["Trillium Trading"]
		})
	}

	load(){
		let self = this
		const apiClient = createApiClient();
		apiClient.get(MWBaseURL()+"account_list?"+GetParams(self.state))
		.then(data => {
			$("#firmFilter option").remove()
			Array.from(new Set(data.map(x => x.class_name))).forEach(function(item, index){
				if(item === "Trillium Trading"){//Trillium trading should always be selected
					$("#firmFilter").append('<option value="'+item+'" disabled>'+item+'</option>');
				}else{
					$("#firmFilter").append('<option value="'+item+'">'+item+'</option>');
				}
			})
			$("#firmFilter").selectpicker('val', self.state.firm).selectpicker('refresh');
		}).catch(e => console.log(e));
	}

	render(){
		return (
			<div className="col-lg-2 col-md-3 col-sm-4 pt-1 input-group">
				<select ref={this.selectRef} className="selectpicker form-control" id="firmFilter" onChange={this.setFilterValue} title="Filter Firm" data-live-search="true" data-actions-box="true" data-size="10" multiple></select>
				<div className="input-group-append">
					<button className="btn btn-outline-secondary clear-btn" type="button" onClick={this.clearFilter}><img src="icon.png" alt="X"/></button>
				</div>
			</div>
		)
	}
}
export default FirmFilter;